var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaq = function SvgFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.455 40.41v1.193c0 1.974 1.59 3.578 3.545 3.578h10.992l8.238 8.61c.74.772 2.03.243 2.03-.832V45.18h2.363c1.955 0 3.545-1.604 3.545-3.578v-21.46c0-1.973-1.59-3.578-3.545-3.578H26.455",
    fill: "#BFD1E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.455 40.41v1.193c0 1.974 1.59 3.578 3.545 3.578h10.992l8.238 8.61c.74.772 2.03.243 2.03-.832V45.18h2.363c1.955 0 3.545-1.604 3.545-3.578v-21.46c0-1.973-1.59-3.578-3.545-3.578h-7.09",
    stroke: "#004996",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.377 5.84h31.895c2.612 0 4.726 2.133 4.726 4.77v22.653c0 1.974-1.59 3.578-3.545 3.578H20.198l-8.237 8.61c-.741.772-2.03.243-2.03-.832V36.84H6.385c-1.956 0-3.545-1.604-3.545-3.578V9.418C2.833 7.444 4.42 5.84 6.377 5.84z",
    fill: "#fff",
    stroke: "#004996",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.91 27.3v2.385m-3.544-11.927c0-2.125 1.44-3.578 3.545-3.578 2.055 0 3.545 1.504 3.545 3.578 0 1.218-.874 2.503-1.748 3.2-1.43 1.151-1.797 2.1-1.797 3.948",
    stroke: "#D64309",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 5)",
    d: "M0 0h56v50H0z"
  })))));
};
export default SvgFaq;